// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3vODs","noInteraction":"EventWrapper_noInteraction__xpXUg","pointerPassthrough":"EventWrapper_pointerPassthrough__ExdaH"};